import React from "react";
import { Route, Routes } from "react-router-dom";
import ROUTES_NAVIGATION from "./routes";
import Warranty from "../components/DealerManagement/Admin/WarrantyManagement/Warranty"
import ExtendedWarranty from "../components/DealerManagement/Admin/WarrantyManagement/ExtendedWarranty"
import AddWarranty from "../components/DealerManagement/Admin/WarrantyManagement/Warranty/AddWarranty";
import EditWarranty from "../components/DealerManagement/Admin/WarrantyManagement/Warranty/EditWarranty";
import AddExtendWarranty from "../components/DealerManagement/Admin/WarrantyManagement/ExtendedWarranty/AddExtendedWarranty";
import EditExtendWarranty from "../components/DealerManagement/Admin/WarrantyManagement/ExtendedWarranty/EditExtendedWarranty";
import ExtendWarrantyApproval from "../components/DealerManagement/Admin/WarrantyManagement/ExtendWarrantyApproval";
import ExtendedWarrantyDetails from "../components/DealerManagement/Admin/WarrantyManagement/ExtendWarrantyApproval/ExtendedWarrantyDetails";
import InspectionExtendWarrantyApproval from "../components/DealerManagement/Admin/WarrantyManagement/InspectionExtendWarrantyApproval";
import InspectionExtendedWarrantyDetails from "../components/DealerManagement/Admin/WarrantyManagement/InspectionExtendWarrantyApproval/InspectionExtendedWarrantyDetails";
import ClaimWarranty from "../components/DealerManagement/Admin/WarrantyManagement/ClaimWarranty";
import ClaimWarrantyDetails from "../components/DealerManagement/Admin/WarrantyManagement/ClaimWarranty/ClaimWarrantyDetails";


const WarrantyRoutes = () => {
  return (
    <>
    <Route
        path={ROUTES_NAVIGATION.WARRANTY}
        element={<Warranty />}
      />
      <Route
        path={ROUTES_NAVIGATION.WARRANTYADD}
        element={<AddWarranty />}
      />
     

      <Route 
      path={ROUTES_NAVIGATION.WARRANTYEDIT}
      element={ <EditWarranty/> }
      />
       <Route
        path={ROUTES_NAVIGATION.EXTENDWARRANTY}
        element={<ExtendedWarranty />}
      />
       <Route
        path={ROUTES_NAVIGATION.EXTENDWARRANTYADD}
        element={<AddExtendWarranty />}
      />
     

      <Route 
      path={ROUTES_NAVIGATION.EXTENDWARRANTYEDIT}
      element={ <EditExtendWarranty/> }
      />
  <Route
        path={ROUTES_NAVIGATION.EXTENDWARRANTYAPPROVAL}
        element={<ExtendWarrantyApproval />}
      />
       <Route
        path={ROUTES_NAVIGATION.EXTENDWARRANTYAPPROVALDETAILS}
        element={<ExtendedWarrantyDetails />}
      />
        <Route
        path={ROUTES_NAVIGATION.INSPECTIONEXTENDEDWARRANTYAPPROVAL}
        element={<InspectionExtendWarrantyApproval />}
      />
      <Route
        path={ROUTES_NAVIGATION.INSPECTIONEXTENDWARRANTYAPPROVALDETAILS}
        element={<InspectionExtendedWarrantyDetails />}
      />
       <Route
        path={ROUTES_NAVIGATION.CLAIMWARRANTY}
        element={<ClaimWarranty />}
      />
       <Route
        path={ROUTES_NAVIGATION.CLAIMWARRANTYDETAILS}
        element={<ClaimWarrantyDetails />}
      />
     

    </>
  );
};

export default WarrantyRoutes;
